import React from 'react';
import styled from 'react-emotion';
import theme from '@jetshop/ui/utils/theme';

const Description = styled('article')`
  line-height: 1.5625rem;
  font-size: 0.9625rem;
  color: ${({ theme }) => theme.colors.product.description};
  a {
    color: ${({ theme }) => theme.colors.product.link.color};
    line-height: inherit;
    text-decoration: none;
    :hover {
      color: ${({ theme }) => theme.colors.product.link.colorHover};
    }
  }
  strong {
    font-weight: bold;
  }
  p {
    font-size: 0.875rem;
    margin-bottom: 0.625rem;
  }
  h1,
  h2,
  h3,
  h4 {
    color: ${({ theme }) => theme.colors.product.descriptionHeader};
    font-style: normal;
    font-weight: bold;
    line-height: 1.4;
    margin-bottom: 0.5rem;
    margin-top: 0.2rem;
    text-rendering: optimizeLegibility;
  }
  h3 {
    font-size: 1.25rem;
  }
  h4 {
    font-size: 1rem;
  }
  ${theme('below.md')} {
    h3 {
      font-size: 0.9375rem;
    }
    h4 {
      font-size: 0.6875rem;
    }
  }
  .even {
    background: #eaeaea;
  }

  pre {
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
`;

const ProductDescription = ({ description }) => (
  <Description
    dangerouslySetInnerHTML={{
      __html: description
    }}
  />
);

export default ProductDescription;
